import styled from "@emotion/styled";
import { FaBars } from "react-icons/fa";
import { Link as ScrollLink } from "react-scroll";

export const Nav = styled.nav`
  background: transparent;
  color: #fff;
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-top: 20px;
  border-radius: 100px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

export const Logo = styled(ScrollLink)`
  img {
    width: 58px; 
    filter: brightness(80%);
    image-rendering: pixelated;
    border:3px solid #990000; 
    border-radius: 50%; 
    &:hover {
      filter: brightness(100%); 
    }
  }
  margin-left: auto; 
  position: fixed;
  top : 20px;
  left: 20px;
  
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavLink = styled(ScrollLink)`
  color: rgb(119, 119, 121);
  font-size: 1.2rem;
  align-items: center;
  height: 100%;
  color: black;
  cursor: pointer;
  text-align: center;
  &:hover {
    color: #f6f6f6;
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: #fff;
  font-size: 1.8rem;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative; 
  flex-grow: 1; 
  .menu-item + .menu-item {
    margin-left: 4rem; 
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    position: fixed;
    top: 90px;
    left: 0; 
    background-color: white; 
    width: 100%; 
    height: calc(100vh - 90px); 
    display: ${({ show }) => (show ? 'flex' : 'none')};
    flex-direction: column; 
    align-items: center; 
    justify-content: center;
    padding-top: 20px; 
    z-index: 999; 
  }
`;


export const CancelButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: black;
  font-size: 1.5rem;
  cursor: pointer;
`;


export const ResumeBtn = styled('a')` 
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #333;
  color: #fff;
  padding: 10px 20px;
  border-radius: 500px;
  font-weight: bold;
  text-decoration: none;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  &:hover {
    background-color: #444;
  }
  position: fixed;
  top: 20px; 
  right: 10px; 
  cursor: pointer;

  @media screen and (max-width: 768px) {
    position: static; 
    margin-top: 10px; 
    margin-left: 1rem; 
  }
`;

